import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

import AddressSelection from 'components/layout/steps/AddressSelection';
import RoofType from 'components/layout/steps/RoofType';
import RoofArea from 'components/layout/steps/RoofArea';
import RoofObstacles from 'components/layout/steps/RoofObstacles';
import EnergyCost from 'components/layout/steps/EnergyCost';
import EnergyConsumption from 'components/layout/steps/EnergyConsumption';
import ElectricCar from 'components/layout/steps/ElectricCar';
// import ElectricalBox from 'components/layout/steps/ElectricalBox';
import Contact from 'components/layout/steps/Contact';
import SimulationRequest from 'components/layout/steps/SimulationRequest';
import HeatingPump from 'components/layout/steps/HeatingPump';
import SimulationResult from 'components/layout/steps/SimulationResult';
import PDFLayout from 'components/layout/PDFLayout';
import QRCodeEvaluation from 'components/layout/steps/QRCodeEvaluation';
import TrackedLayout from 'components/layout/TrackedLayout';

// import shadow root context to access shadow root in child components
import { ShadowRootContext } from './context/ShadowRootContext';
// import styles here to inject directly into shadow-dom
import appStyles from 'assets/styles/App.scss';
import pdfStyles from 'assets/styles/PDF.scss';
import { GoogleMapsProvider } from './context/GoogleContext';

import {
  guardedAddressSelection,
  guardedRoofTypeLoader,
  guardedRoofAreaLoader,
  guardedObstaclesLoader,
  guardedEnergyConsumptionLoader,
  guardedEnergyCostLoader,
  // guardedElectricalBoxLoader,
  guardedContactLoader,
  guardedQRCodeEvaluationLoader
} from './security/guardedLoader.js';

import {
  createHashRouter,
  RouterProvider,
} from "react-router-dom";

import { transitionLoader } from 'components/transitionLoader';

const router = createHashRouter([
  {
    path: "/",
    element: <TrackedLayout />,
    // element: <App />,
    children: [
      {
        element: <App />,
        children: [
          {
            path: "",
            element: <AddressSelection />,
            loader: guardedAddressSelection // transitionLoader
          },
          {
            path: "RoofType",
            element: <RoofType />,
            loader: guardedRoofTypeLoader // transitionLoader
          },
          {
            path: "RoofArea",
            element: <RoofArea />,
            loader: guardedRoofAreaLoader // transitionLoader
          },
          {
            path: "RoofObstacles",
            element: <RoofObstacles />,
            loader: guardedObstaclesLoader // transitionLoader
          },
          {
            path: "EnergyCost",
            element: <EnergyCost />,
            loader: guardedEnergyCostLoader // transitionLoader
          },
          {
            path: "EnergyConsumption",
            element: <EnergyConsumption />,
            className: "full",
            loader: guardedEnergyConsumptionLoader // transitionLoader
          },
          // {
          //   path: "ElectricalBox",
          //   element: <ElectricalBox />,
          //   className: "full",
          //   loader: guardedElectricalBoxLoader //transitionLoader
          // },
          {
            path: "Contact",
            element: <Contact />,
            className: "full",
            loader: guardedContactLoader // transitionLoader
          },
          {
            path: "/SimulationRequest",
            element: <SimulationRequest />,
            className: "full",
            loader: guardedContactLoader // transitionLoader
          },
          {
            path: "ElectricCar",
            element: <ElectricCar />,
            className: "full",
            loader: guardedEnergyConsumptionLoader // transitionLoader
          },
          {
            path: "HeatingPump",
            element: <HeatingPump />,
            className: "full",
            loader: guardedEnergyConsumptionLoader // transitionLoader
          },
          {
            path: "SimulationResult",
            element: <SimulationResult />,
            className: "full",
            loader: guardedContactLoader // transitionLoader
          },
          {
            path: "PDF",
            element: <PDFLayout />,
            className: "full",
            loader: transitionLoader
          },
          {
            path: "QR",
            element: <QRCodeEvaluation />,
            className: "full",
            loader: guardedQRCodeEvaluationLoader
          },
        ]
      }]
  }
]);

class E3DCConfiguratorShadowRootComponent extends HTMLElement {
  connectedCallback() {

    const shadowRoot = this.attachShadow({ mode: 'open' });

    const appStyleEl = document.createElement('style');
    appStyleEl.textContent = appStyles;
    shadowRoot.appendChild(appStyleEl);

    const pdfStyleEl = document.createElement('style');
    pdfStyleEl.textContent = pdfStyles;
    shadowRoot.appendChild(pdfStyleEl);

    const container = document.createElement('div');
    shadowRoot.appendChild(container);

    ReactDOM.createRoot(container).render(
      <React.StrictMode>
        <ShadowRootContext.Provider value={shadowRoot}>
          <GoogleMapsProvider>
            <RouterProvider router={router} />
          </GoogleMapsProvider>
        </ShadowRootContext.Provider>
      </React.StrictMode>
    );
  }
}

customElements.define('e3dc-configurator-shadow-root-component', E3DCConfiguratorShadowRootComponent);
document.addEventListener('DOMContentLoaded', () => {
  const shadowRootElement = document.createElement('e3dc-configurator-shadow-root-component');
  const configurator = document.getElementById('e3dc-configurator');
  if (configurator) {
    configurator.appendChild(shadowRootElement);
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
